export interface IConfigurationApiUrl {
  apiVersion: number;
  url: string;
}

export const defaultConfigurationApiUrl: IConfigurationApiUrl = {
  apiVersion: 0,
  url: ''
};

export interface IConfigurationApi {
  protocol: string;
  host: string;
  port: string;
  baseUrls: Array<string>;
  apiUrls: {
    apiAuthUrl: IConfigurationApiUrl;
    apiWorkflowUrl: IConfigurationApiUrl;
    apiWorkflow2Url: IConfigurationApiUrl;
    apiSecurityContext: IConfigurationApiUrl;
    apiDict: IConfigurationApiUrl;
    apiSecurityUrl: IConfigurationApiUrl;
    apiCockpitUrl: IConfigurationApiUrl;
    apiVendorsUrl: IConfigurationApiUrl;
    apiDataLedgerUrl: IConfigurationApiUrl;
    apiPlatformUrl: IConfigurationApiUrl;
    apiAccountingUrl: IConfigurationApiUrl;
    apiSitesUrl: IConfigurationApiUrl;
    apiOrdersUrl: IConfigurationApiUrl;
    apiCatalogUrl: IConfigurationApiUrl;
    apiCatalogUrlForPriceList: IConfigurationApiUrl;
    apiOSAUrl: IConfigurationApiUrl;
    apiBRUrl: IConfigurationApiUrl;
    apiLogUrl: IConfigurationApiUrl;
    apiReportingUrl: IConfigurationApiUrl;
    apiNotificationUrl: IConfigurationApiUrl;
    apiSendUrl: IConfigurationApiUrl;
    apiMarketplaceUrl: IConfigurationApiUrl;
    apiBusinessRulesUrl: IConfigurationApiUrl;
    apiMessagingUrl: IConfigurationApiUrl;
    apiMerchandisingUrl: IConfigurationApiUrl;
    apiDataQualityUrl: IConfigurationApiUrl;
    apiDataDistrBorjomiUrl: IConfigurationApiUrl;
    apiMock: IConfigurationApiUrl;
    apiIsmUrl: IConfigurationApiUrl;
    apiFileSharingUrl: IConfigurationApiUrl;
    apiDataSharingUrl: IConfigurationApiUrl;
    apiVision: IConfigurationApiUrl;
    apiWorkScheduleUrl: IConfigurationApiUrl;
    apiCrowdUrl: IConfigurationApiUrl;
    apiPaymentUrl: IConfigurationApiUrl;
    apiVacancyUrl: IConfigurationApiUrl;
    apiPartnerUrl: IConfigurationApiUrl;

  };
}

export const defaultConfigurationApi: IConfigurationApi = {
  protocol: 'http',
  host: 'localhost',
  port: '80',
  baseUrls: ['/biretail/restapi/v.1', '/restapi/v.1', '/restapi/v.2', '/biretail/restapi/v.3','/biretail/restapi/v.4'],
  apiUrls: {
    apiAuthUrl: {apiVersion: 0, url: '/auth'},
    apiWorkflowUrl: {apiVersion: 0, url: '/wf'},
    apiWorkflow2Url: {apiVersion: 2, url: '/wf'},
    apiSecurityContext: {apiVersion: 0, url: '/securitycontext'},
    apiDict: {apiVersion: 0, url: '/dict'},
    apiSecurityUrl: {apiVersion: 0, url: '/security'},
    apiCockpitUrl: {apiVersion: 0, url: '/performance'},
    apiVendorsUrl: {apiVersion: 0, url: '/vendor/reports'},
    apiDataLedgerUrl: {apiVersion: 0, url: '/dataledger'},
    apiPlatformUrl: {apiVersion: 0, url: '/platform'},
    apiAccountingUrl: {apiVersion: 0, url: '/accounting'},
    apiSitesUrl: {apiVersion: 0, url: '/sites'},
    apiOrdersUrl: {apiVersion: 0, url: '/orders'},
    apiCatalogUrl: {apiVersion: 0, url: '/catalog'},
    apiCatalogUrlForPriceList: {apiVersion: 1, url: '/catalog'},
    apiOSAUrl: {apiVersion: 0, url: '/osa'},
    apiBRUrl: {apiVersion: 0, url: '/rules'},
    apiLogUrl: {apiVersion: 0, url: '/logger'},
    apiReportingUrl: {apiVersion: 0, url: '/reporting'},
    apiNotificationUrl: {apiVersion: 1, url: '/notification'},
    apiSendUrl: {apiVersion: 0, url: '/notification'},
    apiMarketplaceUrl: {apiVersion: 0, url: '/marketplace'},
    apiBusinessRulesUrl: {apiVersion: 1, url: '/businessrules'},
    apiMessagingUrl: {apiVersion: 0, url: '/message'},
    apiMerchandisingUrl: {apiVersion: 0, url: '/merch'},
    apiDataQualityUrl: {apiVersion: 1, url: 'dataquality'},
    apiDataDistrBorjomiUrl: {apiVersion: 0, url: '/externaldata'},
    apiMock: {apiVersion: 1, url: '/mock'},
    apiIsmUrl: {apiVersion: 1, url: '/external/ism'},
    apiFileSharingUrl: {apiVersion: 1, url: '/filesharing'},
    apiDataSharingUrl:{apiVersion: 1, url: '/datasharing'},
    apiVision: {apiVersion: 0, url: '/vision'},
    apiWorkScheduleUrl: {apiVersion: 1, url: '/workschedules'},
    apiCrowdUrl: {apiVersion: 1, url: '/crowd'},
    apiPaymentUrl: {apiVersion: 1, url: '/payment'},
    apiVacancyUrl: {apiVersion: 1, url: '/vacancy'},
    apiPartnerUrl: {apiVersion: 1, url: '/partner'}

  }
};

export interface IConfigurationLanguage {
  defaultLang: string;
  showLang: boolean;
  langList: Array<string>;
}

export const defaultConfigurationLanguage: IConfigurationLanguage = {
  defaultLang: 'ru',
  showLang: false,
  langList: ['en', 'ru', 'ro', 'ua']
};

export interface IConfigurationAuth {
  realm: string;
  module: string;
}

export const defaultConfigurationAuth: IConfigurationAuth = {
  realm: '',
  module: ''
};

export interface IConfigurationProfile {
  showAccountInformationInProfile: boolean;
  showExtendedUserProfileDropDown: boolean;
  showInfoMobileProfile: boolean;
}

export const defaultConfigurationProfile: IConfigurationProfile = {
  showInfoMobileProfile: false,
  showAccountInformationInProfile: false,
  showExtendedUserProfileDropDown: true

};

export interface IConfigurationGoogle {
  googleApiClientId: string;
  googleApiScope: string;
  googleApiDiscovery_docs: Array<string>;
  GoogleApi_key: string;
}

export const defaultConfigurationGoogle: IConfigurationGoogle = {
  googleApiClientId: '796387608670-ffu9ptl7vfv2ohml5arjcfsic16pfs2k.apps.googleusercontent.com',
  googleApiScope: 'profile openid email https://www.googleapis.com/auth/drive https://www.googleapis.com/auth/spreadsheets',
  googleApiDiscovery_docs: ["https://www.googleapis.com/discovery/v1/apis/drive/v3/rest", "https://sheets.googleapis.com/$discovery/rest"],
  GoogleApi_key: 'AIzaSyC9ubbKLcoK6xq3oYRV7MowbxnlxXX94Nc',
};

export interface IConfigurationModuleLogin {
  loginType: string;
  goFAQ: string;
  showLinkToFAQ: boolean;
  supportEmail: string;
  enableSelfRegistration: boolean;
  enableGoogleSignIn: boolean;
  showTutorialVideo: boolean;
  showTryDemoButton: boolean;
  showAboutUsButton: boolean;
  showContacts: boolean;
  showContactOnlyEmail: boolean;
  enableRestorePassword: boolean;
  contactsConfig: {
    showViber: boolean;
    showPhone: boolean;
    showEmail: boolean;
  };
}

export const defaultConfigurationModuleLogin: IConfigurationModuleLogin = {
  loginType: 'common',
  goFAQ: '',
  showLinkToFAQ: false,
  supportEmail: 'support@redfactory.io',
  enableSelfRegistration: false,
  enableGoogleSignIn: false,
  enableRestorePassword: true,
  showTutorialVideo: false,
  showTryDemoButton: false,
  showAboutUsButton: false,
  showContacts: false,
  showContactOnlyEmail: false,
  contactsConfig: {
    showViber: false,
    showPhone: false,
    showEmail: true
  }
};


export interface IConfigurationModuleMain {
  showSupportBlock: boolean;
}
export const defaultConfigurationModuleMain: IConfigurationModuleMain = {
  showSupportBlock: false
};

export interface IConfigurationModuleOrders {
  showStock: boolean;
}
export const defaultConfigurationModuleOrders:IConfigurationModuleOrders = {
  showStock: false
};

export interface IConfigurationModuleDataLedger {
  showPaymentDelay: boolean;
  showAddressForPartner: boolean;
  hideAdditionalUserAttributes: boolean;
  showSuppliersCodeForPartner: boolean;
}
export const defaultConfigurationModuleDataLedger: IConfigurationModuleDataLedger = {
  showPaymentDelay: false,
  showAddressForPartner: false,
  hideAdditionalUserAttributes: false,
  showSuppliersCodeForPartner: false
};
export interface IConfigurationModuleChat {
  enabled: boolean;
}
export const defaultConfigurationModuleChat: IConfigurationModuleChat = {
  enabled: false
};

export interface IConfigurationModules {
  login: IConfigurationModuleLogin;
  main: IConfigurationModuleMain;
  orders: IConfigurationModuleOrders;
  dataLedger: IConfigurationModuleDataLedger;
  chat: IConfigurationModuleChat;
}
export const defaultConfigurationModules:IConfigurationModules = {
  login: {...defaultConfigurationModuleLogin},
  main: {...defaultConfigurationModuleMain},
  orders: {...defaultConfigurationModuleOrders},
  dataLedger: {...defaultConfigurationModuleDataLedger},
  chat: {...defaultConfigurationModuleChat}
};


export interface IUserInfoComponentConfiguration {
  className: string;
  parameters: object;
}
export const defaultUserInfoComponentConfiguration: IUserInfoComponentConfiguration = {
  className: '',
  parameters: {}
};
export interface IConfigurationHeader {
  goLandingSite: string;
  userInfoComponents: Array<IUserInfoComponentConfiguration>;

}
export const defaultConfigurationHeader: IConfigurationHeader = {
  goLandingSite: '',
  userInfoComponents: [
    {className: 'app-user-info-detail-separator', parameters: null},
    {className: 'app-user-info-detail-version-info', parameters: null},
    {className: 'app-user-info-detail-login-info', parameters: null},
    {className: 'app-user-info-detail-email-info', parameters: null},

    {className: 'app-user-info-detail-separator', parameters: null},
    {className: 'app-user-info-detail-my-company-info', parameters: null},
    {className: 'app-user-info-detail-legal-id-info', parameters: null},

    // {className: 'app-user-info-detail-separator', parameters: null},
    {className: 'app-user-info-detail-datasource-selector', parameters: null},

    // {className: 'app-user-info-detail-separator', parameters: null},
    {className: 'app-user-info-detail-logout-button', parameters: null}
  ]
};

export interface IConfiguration {
  api: IConfigurationApi;
  language: IConfigurationLanguage;
  auth: IConfigurationAuth;
  profile: IConfigurationProfile;
  google: IConfigurationGoogle;
  header: IConfigurationHeader;

  theme: string;
  start_page: string;

  pagesConfig: IConfigurationModules;
}

export const defaultConfiguration: IConfiguration = {
  api: {...defaultConfigurationApi},
  language: {...defaultConfigurationLanguage},
  auth: {...defaultConfigurationAuth},
  profile: {...defaultConfigurationProfile},
  google: {...defaultConfigurationGoogle},
  header: {...defaultConfigurationHeader},

  theme: 'portal',
  start_page: 'main',

  pagesConfig: {...defaultConfigurationModules},
};

export interface IConfigurationState {
  data: IConfiguration;
  isLoaded: boolean;

}

export const initialConfigurationState: IConfigurationState = {
  data: {...defaultConfiguration},
  isLoaded: false
};
